/**
* 佣金管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>佣金比例设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="销售名称">
        <el-input size="small" v-model="formInline.userName" placeholder="请输入销售名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading"
              border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column align="center" sortable prop="realName" label="销售名称">
      </el-table-column>
      <el-table-column align="center" sortable prop="lowerLimit,upperLimit" label="提成范围(元)">
        <template slot-scope="scope"> {{scope.row.lowerLimit}}~{{scope.row.upperLimit}} </template>
       </el-table-column>
      <el-table-column align="center" sortable prop="proportion" label="佣金比例(%)">
      </el-table-column>
      <el-table-column align="center" sortable prop="updateByName" label="更新人员">
      </el-table-column>
      <el-table-column align="center" sortable prop="updateTime" label="更新时间">
        <template slot-scope="scope">
          <div>{{ scope.row.updateTime|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteCommission(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="销售人员" prop="userId">
         <!-- <el-input size="small" v-model="editForm.userId" auto-complete="off" placeholder="请输入用户名"></el-input>-->
          <el-select v-model="editForm.userId" filterable  placeholder="请选择">
            <el-option
              v-for="item in saleNames"
              :key="item.id"
              :label="item.userName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提成范围" prop="lowerLimit">
          <el-col :span="11">
            <el-input-number size="small" v-model="editForm.lowerLimit" placeholder="请输入下限" :min="1" :max="999999"
                             style="width: 100%;" controls-position="right"></el-input-number>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-input-number size="small" v-model="editForm.upperLimit" placeholder="请输入上限" :min="1" :max="999999"
                             style="width: 100%;" controls-position="right"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="佣金比例" prop="proportion">
          <el-input-number size="small" v-model="editForm.proportion" auto-complete="off" :precision="2" :step="0.1"
                           :max="10" style="width: 46%;" controls-position="right"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {
  commissionList,
  commissionEdit,
  commissionSave,
  commissionDelete
} from '../../api/commissionMg'
import Pagination from '../../components/Pagination'
import {hotelManger} from "../../api/hotelMg";

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加佣金',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      // 编辑与添加
      editForm: {
        id: null,
        userId: null,
        lowerLimit: 0,
        upperLimit: 0,
        proportion: 0,
        token: localStorage.getItem('logintoken')
      },
      // 选择数据
      selectdata: [],
      //销售人员信息
      saleNames:[],
      // rules表单验证
      rules: {
        userid: [
          {required: true, message: '请选择销售人员', trigger: 'blur'}
        ],
        lowerLimit: [{required: true, message: '请输入提成范围', trigger: 'blur'}],
        upperLimit: [{required: true, message: '请输入提成范围', trigger: 'blur'}],
        proportion: [
          {required: true, message: '请输入佣金比例', trigger: 'blur'}
        ]
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        pageNum: 1,
        pageSize: 10,
        userName: ''
      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      //角色列表
      roleList: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.querySales()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleChange(value) {
      console.log(value);
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      this.loading = false
      console.log(parameter)
      //获取用户列表
      commissionList(parameter).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.result.rows
          // 分页赋值
          // 分页赋值
          this.pageparm.currentPage = res.result.pagination.current
          this.pageparm.pageSize = res.result.pagination.pageSize
          this.pageparm.total = res.result.pagination.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.title = '修改佣金'
      this.editForm.id = row.id
      this.editForm.userId = row.userId
      this.editForm.lowerLimit = row.lowerLimit
      this.editForm.upperLimit = row.upperLimit
      this.editForm.proportion = row.proportion
    },
    handleAdd: function (index, row) {
      this.editFormVisible = true
      this.title = '添加佣金'
      // this.editForm.id = ''
      // this.editForm.userId = ''
      // this.editForm.lowerLimit = 0
      // this.editForm.upperLimit = 0
      // this.editForm.proportion = 0
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.editForm.id == undefined || this.editForm.id.length <= 0) {
            // 新增保存
            commissionSave(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.success) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  });
                  this.$refs['editForm'].resetFields();
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            //修改保存
            commissionEdit(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.success) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
          }
        } else {
          return false
        }
      })
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 删除用户
    deleteCommission(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        commissionDelete({ids: row.id})
          .then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '数据已删除!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('数据删除失败，请稍后再试！')
          })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
    querySales:function(){
      //酒店销售人员
      hotelManger('3').then(res=>{
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          res.result.forEach(item =>{
            this.saleNames.push(item);
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: res.msg
        })
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.line {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/hotel/Commission.vue